import { render } from "./Frequency.vue?vue&type=template&id=05db8a74"
import script from "./Frequency.vue?vue&type=script&lang=js"
export * from "./Frequency.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./Frequency.vue?vue&type=style&index=0&id=05db8a74&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__